import React, { useState, useEffect, useRef } from "react";
import WaveformPlayer from "../../utils/waveformPlayer";
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Dialog, Snackbar } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fetchVoiceCallSession,
  fetchCandidateProfile,
  fetchVoiceAssistants,
  fetchAssessmentInviteDetails,
  fetchVideoCallDetails,
  clearCandidateSessionData,
  getPreScreeningReport,
  getVoiceSessionStatus,
  updateCandidateDetails,
  createShareLink,
  sendShareEmail,
} from "../../Redux/ActionCreators/candidateAction";
import { Table } from "react-bootstrap";
import {
  assignedStage,
  fetchAvailableSlots,
  fetchJobById,
} from "../../Redux/ActionCreators/jobsAction";
import TestReport from "../My-assessment/test-report";
import { FaPlay } from "react-icons/fa";
import moment from "moment";
import CircularProgressRing from "../../utils/CircularProgressRing";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import TimeZone from "../../utils/all_timezones.json";
import ApplyStageModal from "../../utils/applyStageModal";
import Lightbox from "../../utils/lightbox";
import CreatableSelect from 'react-select/creatable';

const StageIds = {
  Assessment: "293e9b95-4610-48f2-ae93-c7264cae7d6a",
  "Video Call": "ed658e02-1549-4d9e-a735-1f1c1e385f46",
  "Voice Call": "fd40e3d2-38a9-4cef-937a-93ef6a42d045",
};

const QUESTION_TYPE_ID_TO_LABEL = {
  "4c524f2f-48de-493e-894f-4f0bd931b4c9": "MCQ",
  "64468292-d741-4e52-893f-0846dd56830d": "Numeric",
  "4ffc711b-2f10-470b-b162-85f2a2f1e220": "Yes/No",
  "30afb159-85d7-490d-afcd-1af9497531ae": "Short answer",
};

const STATUS_COLORS = {
  COMPLETED: "#4CC948",
  EXPIRED: "#FF1C58",
  ASSIGNED: "#0048B7",
  UNASSIGNED: "#8A9199",
};

const HIRING_STATUS_IDS = {
  Hired: "a7db4d99-448f-4993-be64-e2000d499200",
  "Short Listed": "b4c604a1-7cb6-4e8d-8bd8-b4d7e92a8fbb",
  "On Hold": "a3f100dc-eedf-4965-82c2-84e3025dc35b",
  Rejected: "520f0726-efe2-4f5a-8ad4-81436a979663",
};

const buttonStyleMap = {
  Rejected: { border: "1px solid #FF1C58", background: "#FF1C581A" },
  "On Hold": { border: "1px solid #FFC857", background: "#FFC8571A" },
  "Short Listed": { border: "1px solid #00DDFF", background: "#00DDFF1A" },
  Hired: { border: "1px solid #4CC948", background: "#4CC9481A" },
};

// For mapping icon + label
const QUICK_ACTIONS = [
  {
    name: "Rejected",
    icon: "/images/cross-black.svg",
    width: 14,
    height: 14,
  },
  {
    name: "On Hold",
    icon: "/images/pause-black.svg",
    width: 14,
    height: 14,
  },
  {
    name: "Short Listed",
    icon: "/images/check-black.svg",
    width: 14,
    height: 14,
  },
  {
    name: "Hired",
    icon: "/images/hired-black.svg",
    width: 14,
    height: 14,
  },
];


const ALLOWED_REASSIGN_STATUSES = [
  "not scheduled",
  "failed",
  "expired",
];

const normalizeStatus = (status) => (status || "").trim().toLowerCase();

const CandidateProfile = (props) => {
  const [showSummaryPopup, setShowSummaryPopup] = useState(false);
  const [loadingCall, setLoadingCall] = useState(false);
  const [showAssistantModal, setShowAssistantModal] = useState(false);
  const [assistants, setAssistants] = useState([]);
  const [selectedAssistant, setSelectedAssistant] = useState(null);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tabLoading, setTabLoading] = useState(false);
  const [assessmentStatus, setAssessmentStatus] = useState("idle");
  const [showInlineReport, setShowInlineReport] = useState(false);
  const [inlineReportId, setInlineReportId] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [initiatingVideoCall, setInitiatingVideoCall] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("error");
  const [snackMessage, setSnackMessage] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioLoading, setAudioLoading] = useState(true);
  const [stageLoading, setStageLoading] = useState(false);
  const [scheduleDate, setScheduleDate] = useState(new Date());
  const [timezone, setTimezone] = useState(null);
  const [slotId, setSlotId] = useState(null);
  const [modalType, setModalType] = useState("");
  const [expandSummary, setExpandSummary] = useState(false);
  const [expandRecommendation, setExpandRecommendation] = useState(false);
  const [showPhoneCheckModal, setShowPhoneCheckModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showScorePopup, setShowScorePopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupData, setPopupData] = useState([]);
  const [assignProgress, setAssignProgress] = useState({
    current: 0,
    total: 0,
  });
  const [refreshing, setRefreshing] = useState(false);
  const [showAllCheatingImages, setShowAllCheatingImages] = useState(false);
  const [openProctorLightbox, setOpenProctorLightbox] = useState(false);
  const [selectedProctorImage, setSelectedProctorImage] = useState("");
  const [selectedProctorIndex, setSelectedProctorIndex] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [shareEmails, setShareEmails] = useState([]);
  const [shareLoading, setShareLoading] = useState(false);
  const [shareData, setShareData] = useState(null);
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [preselectStage, setPreselectStage] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tooltipRef = useRef([]);
  const params = useParams();
  let jobId = params.jobId;
  let candidateId = params.candidateId;
  if (!jobId && props.jobId) jobId = props.jobId;
  if (!candidateId && props.candidateId) candidateId = props.candidateId;
  const isSharedReport = props.isSharedReport === true;
  const hideSensitive = props.hideSensitive === true;

  const candidate = useSelector((state) => state.candidates.selectedCandidate);
  const videoSession = useSelector(
    (state) => state.candidates.videoSessionData
  );
  const voiceSession = useSelector((state) => {
    const session = state.candidates.voiceSessionData;
    return session?.job_candidate_id === candidate?.id ? session : null;
  });
  const assessmentInviteDetails = useSelector(
    (state) => state.candidates.assessmentInviteDetails
  );
  const latestJob = useSelector((state) => state.jobs.latestJob);

  const availableSlots = useSelector((state) => state.jobs.availableSlots);

  const preQualifyingReport = useSelector(
    (state) => state.candidates.preQualifyingReport
  );

  const fromTab = location.state?.fromTab || "prescreening";

  // PROCTORING ANALYSIS
  let proctoring = videoSession?.result?.proctoring_analysis;
  let cheatingFrames = [];

  if (proctoring?.samples?.length > 0) {
    cheatingFrames = proctoring.samples.filter(
      (s) => s?.llm_eval?.cheating_detected === true
    );
  }

  const tabTypeMap = {
    prescreening: 0,
    voice: 1,
    assessment: 2,
    video: 3,
  };

  const [testType, setTestType] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (!jobId || !candidateId) {
        setLoading(false);
        return;
      }
      setLoading(true);
      dispatch(clearCandidateSessionData());

      await dispatch(fetchJobById(jobId));
      await dispatch(fetchCandidateProfile(jobId, candidateId));

      const payload = {
        job_id: jobId,
        job_candidate_id: candidateId
      };

      const res = await dispatch(createShareLink(payload));
      if (res.success) {
        setShareData(res.data);
      }

      setLoading(false);
    };

    fetchData();
  }, [jobId, candidateId, dispatch]);

  useEffect(() => {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const matched = TimeZone.find((tz) => tz.value === detected);
    if (matched) setTimezone(matched);
  }, []);

  const score = candidate?.match_score || 0;

  const changeType = async (typeIndex) => {
    setTestType(typeIndex);
    setTabLoading(true);

    try {
      if (typeIndex === 0) {
        // Pre Screening
        const PRE_SCREENING_STAGE_ID = "3dab71cf-c680-4983-a109-1cff0953999b";
        const preScreeningStages = candidate?.hiring_stages?.filter(
          (stage) => stage.hiring_stage_id === PRE_SCREENING_STAGE_ID
        );
        const preScreeningStage =
          preScreeningStages?.reduce((latest, curr) =>
            new Date(curr.created_at) > new Date(latest.created_at)
              ? curr
              : latest
          ) || null;
        const status = preScreeningStage?.status?.name?.trim().toLowerCase();
        if (status === "completed") {
          // always clear previous report before fetching new one
          dispatch({ type: "CLEAR_PREQUALIFYING_REPORT" });
          await dispatch(getPreScreeningReport(candidateId));
        }
      }

      if (typeIndex === 1 && candidate?.voice_call_id && !voiceSession) {
        await dispatch(fetchVoiceCallSession(candidate.voice_call_id));
      }

      if (typeIndex === 2 && candidate?.invite_id && !assessmentInviteDetails) {
        await dispatch(fetchAssessmentInviteDetails(candidate.invite_id));
      }

      if (typeIndex === 3 && candidate?.video_call_id && !videoSession) {
        await dispatch(fetchVideoCallDetails(candidate.video_call_id));
      }
    } catch (error) {
      console.error("Error in changeType:", error);
    } finally {
      setTabLoading(false);
    }
  };

  useEffect(() => {
    if (!candidate?.id) return;
    setTestType((prev) => {
      if (prev === 0 && fromTab) {
        const tabIndex = tabTypeMap[fromTab] ?? 0;
        changeType(tabIndex);
      }
      return prev;
    });
  }, [fromTab, candidate]);

  useEffect(() => {
    if (!window.bootstrap) return;

    // Destroy old tooltips
    tooltipRef.current.forEach((t) => t.dispose?.());
    tooltipRef.current = [];

    // Recreate tooltips
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );

    tooltipTriggerList.forEach((el) => {
      const tooltip = new window.bootstrap.Tooltip(el, {
        trigger: "hover"
      });
      tooltipRef.current.push(tooltip);
    });

    // 🔥 RETURN CLEANUP — runs on unmount or before re-running this effect
    return () => {
      tooltipRef.current.forEach((t) => t.dispose?.());
      tooltipRef.current = [];
    };
  }, [
    cheatingFrames,
    showAllCheatingImages,
    latestJob?.enable_candidate_report_share,
    shareData?.view_count
  ]);

  const handleVoiceCall = async () => {
    setLoadingCall(true);
    const result = await dispatch(fetchVoiceAssistants());
    setLoadingCall(false);

    if (result.success) {
      setAssistants(result.data);
      setShowAssistantModal(true);
    }
    setLoadingCall(false);
  };

  const snackClosed = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackOpen(false);
  };

  const showSnack = (message, severity = "error") => {
    setSnackMessage(message);
    setSnackSeverity(severity);
    setSnackOpen(true);
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };
  const formatDateOnly = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    return date.toLocaleDateString("en-GB", options);
  };
  const formatExpiry = (dateString) => {
    return moment(dateString).format("MMMM-DD-YYYY");  
  };

  const sendVideoInvite = async () => {
    if (!scheduleDate || (modalType === "voice" && (!timezone || !slotId))) {
      return showSnack("Please select all fields.");
    }

    const basePayload = {
      job_hiring_stage_id: filterStageId,
      job_candidate_id: candidate?.id,
      schedule_date: new Date(scheduleDate).toISOString(),
      expire_at: new Date(scheduleDate).toISOString(),
      valid_till: new Date(scheduleDate).toISOString(),
      trigger_now: false,
    };

    if (modalType === "voice") {
      basePayload.current_timezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
      basePayload.schedule_timezone = timezone.value;
      basePayload.slot_id = slotId;
    }
    const payload = [basePayload];

    setStageLoading(true);
    const status = await dispatch(assignedStage(jobId, payload));
    setStageLoading(false);

    if (status === 200) {
      await dispatch(fetchCandidateProfile(jobId, candidateId));
      setModalType("");
      setShowVideoModal(false);
      setSlotId(null);
    } else {
    }
  };

  const handleVoiceRefresh = async () => {
    if (!currentStage?.created_at) return;

    const createdAt = new Date(currentStage.created_at);
    const now = new Date();
    const diffMinutes = Math.floor((now - createdAt) / 60000);

    if (diffMinutes < 15) {
      const waitTime = 15 - diffMinutes;
      const message = `Voice call triggered at ${formatDateTime(
        currentStage.created_at
      )}. Please wait ${waitTime} more minute${
        waitTime > 1 ? "s" : ""
      } before refreshing.`;
      setSnackMessage(message);
      setSnackSeverity("info");
      setSnackOpen(true);
    } else {
      try {
        setRefreshing(true);
        setTabLoading(true);
        await dispatch(getVoiceSessionStatus(candidate.voice_call_id));
        await dispatch(fetchCandidateProfile(jobId, candidateId));
        setSnackSeverity("success");
        setSnackMessage("Candidate profile updated successfully.");
        setSnackOpen(true);
      } catch (error) {
        setSnackSeverity("error");
        setSnackMessage("Failed to refresh profile. Please try again.");
        setSnackOpen(true);
      } finally {
        setRefreshing(false);
        setTabLoading(false);
      }
    }
  };

  const stagePermissionMap = React.useMemo(() => {
    if (!candidate?.hiring_stages?.length) return {};

    const grouped = {};

    candidate.hiring_stages.forEach((stage) => {
      const masterStageId = stage.hiring_stage_id; // ✅ MASTER ID
      if (!masterStageId) return;

      if (!grouped[masterStageId]) {
        grouped[masterStageId] = [];
      }
      grouped[masterStageId].push(stage);
    });

    const result = {};

    Object.entries(grouped).forEach(([masterStageId, records]) => {
      const latest = records.reduce((a, b) =>
        new Date(b.created_at) > new Date(a.created_at) ? b : a
      );

      const latestStatus = normalizeStatus(latest?.status?.name);

      const canAssign =
        !latestStatus || ALLOWED_REASSIGN_STATUSES.includes(latestStatus);

      result[masterStageId] = {
        latestStatus,
        canAssign,
        message: canAssign
          ? null
          :`This stage was already been ${latest.status.name}, you cannot assign again`
,
      };
    });

    return result;
  }, [candidate]);

  if (loading || !candidate) {
    return (
      <div className="candidate-profile">
        <div className="loading-overlay">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">
              Loading candidate profile...
            </span>
          </div>
        </div>
      </div>
    );
  }

  const filterStageId =
    latestJob?.hiring_stages?.length &&
    latestJob?.hiring_stages?.filter(
      (el) =>
        el.hiring_stage_id ===
        StageIds[
          testType === 0
            ? "Pre Screening"
            : testType === 1
            ? "Voice Call"
            : testType === 2
            ? "Assessment"
            : testType === 3
            ? "Video Call"
            : null
        ]
    )[0]?.id;

  const getCurrentStageObject = () => {
    const currentStageId =
      testType === 0
        ? StageIds["Pre Screening"]
        : testType === 1
        ? StageIds["Voice Call"]
        : testType === 2
        ? StageIds["Assessment"]
        : testType === 3
        ? StageIds["Video Call"]
        : null;

    if (!currentStageId || !candidate?.hiring_stages?.length) return null;

    const stages = candidate?.hiring_stages?.filter(
      (stage) => stage.hiring_stage_id === currentStageId
    );

    if (!stages || stages.length === 0) return null;

    // Sort by expire_at (most recent)
    // const latestByExpireAt = stages.reduce((latest, curr) => {
    //   const currExpire = new Date(curr.expire_at);
    //   const latestExpire = new Date(latest.expire_at);
    //   return currExpire > latestExpire ? curr : latest;
    // });

    // return latestByExpireAt;

    return stages.reduce((latest, curr) => {
      const currTime = new Date(
        curr.updated_at || curr.created_at
      ).getTime();

      const latestTime = new Date(
        latest.updated_at || latest.created_at
      ).getTime();

      if (currTime !== latestTime) {
        return currTime > latestTime ? curr : latest;
      }
      
      return curr.id > latest.id ? curr : latest;
    });
  };

  const currentStage = getCurrentStageObject();
  const currentStatus = currentStage?.status?.name?.toUpperCase() || null;

  const hasPreScreeningStage = latestJob?.hiring_stages?.some(
    (stage) => stage.hiring_stage_id === "3dab71cf-c680-4983-a109-1cff0953999b"
  );

  const handleScoreClick = (type) => {
    if (!voiceSession?.result?.analysis?.structured_analysis) return;

    const structured = voiceSession.result.analysis.structured_analysis;
    const weights = structured.weights_used || {};

    let data = [];
    let title = "";
    let score = 0;
    let max = 0;

    if (type === "technical") {
      title = "Technical Weighted Score";
      data = structured.technical_evaluation || [];
      score = structured.technical_weighted_score || 0;
      max = weights.technical || 60; // dynamic max
    } else if (type === "cultural") {
      title = "Cultural Fit Weighted Score";
      data = structured.cultural_fit_evaluation || [];
      score = structured.cultural_fit_weighted_score || 0;
      max = weights.cultural_fit || 15; // dynamic max
    } else if (type === "final") {
      title = "Final Weighted Score";
      data = [
        ...(structured.technical_evaluation || []),
        ...(structured.cultural_fit_evaluation || []),
      ];
      score = structured.final_weighted_score || 0;
      // dynamic final = sum of all weights (fallback 100)
      max =
        (weights.technical || 0) +
          (weights.cultural_fit || 0) +
          (weights.communication || 0) || 100;
    }

    setPopupTitle(`${title} (${score}/${max})`);
    setPopupData(data);
    setShowScorePopup(true);
  };

  const getStageInfo = (stageName) => {
    if (!candidate?.hiring_stages) return { status: "UNASSIGNED", score: null };

    const stageMap = {
      "Pre-Screening": "3dab71cf-c680-4983-a109-1cff0953999b",
      "Voice Interview": StageIds["Voice Call"],
      Assessments: StageIds["Assessment"],
      "Video Interview": StageIds["Video Call"],
    };

    const stageId = stageMap[stageName];
    const stages = candidate.hiring_stages.filter(
      (s) => s.hiring_stage_id === stageId
    );

    if (stages.length === 0) return { status: "UNASSIGNED", score: null };

    const latestStage = stages.reduce((latest, curr) => {
      const latestTime = new Date(latest.created_at).getTime();
      const currTime = new Date(curr.created_at).getTime();
      return currTime > latestTime ? curr : latest;
    });

    const status = latestStage?.status?.name?.toUpperCase() || "UNASSIGNED";
    const score = status === "COMPLETED" ? latestStage?.score : null;

    return { status, score };
  };

  const selectAssignedStage = async (stageId, videoDate, timezone) => {
    const payload = [
      {
        job_hiring_stage_id: stageId,
        job_candidate_id: candidate?.id,
        schedule_date: new Date().toISOString(),
        expire_at: new Date(videoDate).toISOString(),
        valid_till: new Date(videoDate).toISOString(),
        current_timezone: timezone,
        schedule_timezone: timezone,
      },
    ];

    setAssignProgress({ current: 0, total: 1 });
    const status = await dispatch(assignedStage(jobId, payload));

    if (status === 200) {
      await dispatch(fetchCandidateProfile(jobId, candidateId));
      setAssignProgress({ current: 1, total: 1 });
      setIsOpen(false);
    } else {
      showSnack("Failed to assign stage");
    }

    // reset progress
    setAssignProgress({ current: 0, total: 0 });
  };

  const handleStatusChange = async (statusName) => {
    if (!candidate?.id) return;

    const statusId = HIRING_STATUS_IDS[statusName];
    if (!statusId) {
      return showSnack("Invalid hiring status");
    }

    try {
      setStatusLoading(true);

      const res = await dispatch(
        updateCandidateDetails(jobId, candidate.id, { hiring_status_id: statusId })
      );

      if (res?.success) {
        // 🔁 Re-fetch updated profile
        const profileRes = await dispatch(
          fetchCandidateProfile(jobId, candidate.id)
        );

        // (Optional but consistent with candidates.js)
        await dispatch(fetchJobById(jobId));

        if (profileRes?.success) {
          showSnack(
            `Candidate hiring status updated to ${statusName} successfully`,
            "success"
          );
        } else {
          showSnack("Status updated but failed to refresh profile");
        }
      } else {
        showSnack(
          res?.message || `Failed to update status to ${statusName}`
        );
      }
    } catch (err) {
      showSnack(err?.message || `Unexpected error updating ${statusName}`);
    } finally {
      setStatusLoading(false);
    }
  };

  const handleOpenSharePopup = async () => {
    setShowSharePopup(true);
    setShareLoading(true);

    if (shareData) {
      setShareLoading(false);
    } else {
      setShareLoading(false);
      setShowSharePopup(false);
      showSnack("Failed to generate share link", "error");
    }
  };

  const changeEmail = (values) => {
    setShareEmails(values || []);
  };

  const handleSendInvite = async () => {
    if (!shareEmails.length) {
      return showSnack("Please enter at least one email", "error");
    }

    setShareLoading(true);

    const emailArray = shareEmails.map((item) => item.value);

    const payload = {
      share_token: shareData.share_token,
      recipient_emails: emailArray
    };

    const res = await dispatch(sendShareEmail(payload));

    setShareLoading(false);

    if (res.success) {
      showSnack("Invite sent successfully!", "success");
      setShareEmails([]); // reset CreatableSelect
      setShowSharePopup(false);
    } else {
      showSnack(res.message || "Failed to send invite", "error");
    }
  };

  return (
    <div className="candidate-profile">
      <Dialog
        className="schedule-loader"
        open={stageLoading}
        onClose={() => {}}
        PaperProps={{
          sx: {
            boxShadow: "none",
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Dialog>
      <div className="candidate-details">
        <div className="candidate-info">
          {candidate ? (
            <div key={candidate.id} className="candidate-detail-info">
              <div className="candidate-info-image">
                <div className="d-flex align-items-center justify-content-center">
                  {!isSharedReport && (
                  <img
                    src="/images/leftarrow-black-icon.svg"
                    alt=""
                    onClick={() => navigate(`/jobs/${jobId}/candidates`)}
                    className="cursor-pointer"
                  />
                  )}
                  &nbsp;&nbsp;
                  <div className="user-avatar">
                    {candidate.name?.charAt(0).toUpperCase() || "U"}
                  </div>
                  &nbsp;
                  <div>
                    <h4>{candidate?.name}</h4>
                    <p>{candidate?.job?.title}&nbsp;&nbsp;Hiring Status: {candidate?.hiring_status?.name || 'Not updated'}</p>
                  </div>
                </div>
                {!isSharedReport && (
                <div className="share-profile">
                  <p>Share report</p>
                  <div className="d-flex gap-3">
                    <button className="share-btn" 
                    style={{
                      background: latestJob?.enable_candidate_report_share ? "#F75891" : "#D3D3D3",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      if (!latestJob?.enable_candidate_report_share) {
                        navigate(`/jobs/${jobId}/settings`);
                        return;
                      }
                      handleOpenSharePopup();
                    }}
                    data-bs-toggle="tooltip"
                    title={
                      latestJob?.enable_candidate_report_share
                        ? null
                        : "You have disabled share option, click to enable it again"
                    }
                    >
                      <img src="/images/share-icon.svg" alt="" width={16} height={13} />
                      Share
                      </button>
                    <button className="view-btn"
                      style={{
                        background: latestJob?.enable_candidate_report_share ? "#EEF2F7" : "#D3D3D3",
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        if (!latestJob?.enable_candidate_report_share) {
                          navigate(`/jobs/${jobId}/settings`);
                        }
                      }}
                      data-bs-toggle="tooltip"
                      title={latestJob?.enable_candidate_report_share ? null
                          : "You have disabled share option, click to enable it again"
                      }
                    >
                      {shareData?.view_count || 0} Views
                    </button>
                  </div>
                </div>
                )}
              </div>
              <div className="d-flex flex-wrap">
                <div>
                  <div className="candidate-info-details">
                    <div className="details-div">
                      <p>Email</p>
                      {hideSensitive ? <span className="blur-text">***********</span> : (candidate.email || "null")}
                    </div>
                    <div className="details-div">
                      <p>Phone number</p>
                      <h5>{hideSensitive ? <span className="blur-text">***********</span> : (candidate.phone_number || "null")}</h5>
                    </div>
                    <div className="details-div" style={{ width: "200px" }}>
                      <p>Location</p>
                      <h5>{candidate.location || "N/A"}</h5>
                    </div>
                  </div>
                  <div className="candidate-info-details">
                    <div className="details-div">
                      <p>Skills</p>
                      <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                        {candidate.skills?.slice(0, 2).map((skills, index) => (
                          <h5 className="candidate-skills" key={index}>
                            {skills}
                          </h5>
                        ))}
                        {candidate.skills?.length > 2 && (
                          <div className="candidate-skills more-skills">
                            +{candidate.skills.length - 2} more
                            <div className="skills-popup">
                              {candidate.skills.slice(2).map((s, idx, arr) => (
                                <span className="popup-skill-tag" key={idx}>
                                  {s}
                                  {idx < arr.length - 1 && ", "}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="details-div">
                      <p>Qualifications</p>
                      <h5>{candidate.qualifications || "null"}</h5>
                    </div>
                    <div className="details-div" style={{ width: "200px" }}>
                      <p>Years of experience</p>
                      <h5>{candidate?.years_of_experience || "null"}</h5>
                    </div>
                  </div>
                </div>
                {score <= 0 ? null : (
                  <div className="candidate-score">
                    <div className="candidate-score-container">
                      <CircularProgressRing
                        percentage={score || 0}
                        label="Resume score"
                      />
                    </div>
                    <div className="d-flex">
                      <button
                        className="view-summary-btn"
                        onClick={() => setShowSummaryPopup(true)}
                      >
                        View Summary
                      </button>
                      <button
                        className="view-summary-btn"
                        style={{ padding: "0" }}
                        onClick={() => {
                          if (isSharedReport) {
                            setShowAccessModal(true);
                            return;
                          }

                          if (candidate?.resume_url) {
                            const url = candidate.resume_url;
                            const filename = url.split("/").pop();
                            const newTab = window.open(url, "_blank");
                            if (newTab) {
                              const a = newTab.document.createElement("a");
                              a.href = url;
                              a.download = filename;
                              newTab.document.body.appendChild(a);
                              a.click();
                              newTab.document.body.removeChild(a);
                            }
                          }
                        }}
                      >
                        <img
                          src="/images/download-pink.svg"
                          alt=""
                          width={16}
                          height={16}
                        />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <p>Loading candidate profile...</p>
          )}
        </div>
      </div>
      <div className="candidate-tabs">
        {!isSharedReport && (
        <div className="assign-stage">
          <div>
            <button onClick={() => setIsOpen(true)}>
              Assign stage <img src="/images/right-arrow.svg" alt="" />
            </button>
          </div>
          <div className="quick-actions">
            <p>Quick Actions</p>
            <div className="status-btn">
              {statusLoading ? (
                <div
                  className="spinner-border"
                  role="status"
                  style={{ width: "1rem", height: "1rem", color: "#F75891" }}
                >
                  <span className="visually-hidden">Updating status...</span>
                </div>
              ) : (
                QUICK_ACTIONS.map((action) => {
                  const hiringStatusName = candidate?.hiring_status?.name || "In Progress";
                  const isActive = hiringStatusName === action.name;
                  const activeStyle = isActive ? buttonStyleMap[action.name] : {};

                  return (
                    <button
                      key={action.name}
                      style={{
                        background: isActive
                          ? activeStyle?.background
                          : "#E4E9F0",
                        border: isActive
                          ? activeStyle?.border
                          : "1px solid transparent",
                        marginRight: "4px",
                      }}
                      onClick={() => handleStatusChange(action.name)}
                      disabled={isSharedReport}
                    >
                      <img
                        src={action.icon}
                        alt={action.name}
                        width={action.width}
                        height={action.height}
                      />
                    </button>
                  );
                })
              )}
            </div>
          </div>
        </div>
        )}
        <div className="search-tests">
          <h3>Stage results</h3>
          <div className="types-tab d-flex align-items-center">
            {hasPreScreeningStage && (
              <div>
                <div
                  className={
                    testType === 0 ? "type-btn active-type" : "type-btn"
                  }
                  onClick={() => changeType(0)}
                >
                  <div className="type-btn-status">
                    <h4>Pre-Screening</h4>
                    {(() => {
                      const { status } = getStageInfo("Pre-Screening");
                      return (
                        <h5
                          style={{
                            color: STATUS_COLORS[status],
                          }}
                        >
                          {status}
                        </h5>
                      );
                    })()}
                  </div>
                  {(() => {
                    const { score } = getStageInfo("Pre-Screening");
                    if (score !== null) {
                      return (
                        <div className="type-btn-score">
                          <p>{score ? `${score.toFixed(2)}%` : "--"}</p>
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
            )}
            <div>
              <div
                className={testType === 1 ? "type-btn active-type" : "type-btn"}
                onClick={() => changeType(1)}
              >
                <div className="type-btn-status">
                  <h4>Telephonic Interview</h4>
                  {(() => {
                    const { status } = getStageInfo("Voice Interview");
                    return (
                      <h5
                        style={{
                          color: STATUS_COLORS[status],
                        }}
                      >
                        {status}
                      </h5>
                    );
                  })()}
                </div>
                {(() => {
                  const { score } = getStageInfo("Voice Interview");
                  if (score !== null) {
                    return (
                      <div className="type-btn-score">
                        <p>{score ? `${score.toFixed(2)}%` : "--"}</p>
                      </div>
                    );
                  }
                  return null;
                })()}
              </div>
            </div>
            <div>
              <div
                className={testType === 2 ? "type-btn active-type" : "type-btn"}
                onClick={() => changeType(2)}
              >
                <div className="type-btn-status">
                  <h4>Assessments</h4>
                  {(() => {
                    const { status } = getStageInfo("Assessments");
                    return (
                      <h5
                        style={{
                          color: STATUS_COLORS[status],
                        }}
                      >
                        {status}
                      </h5>
                    );
                  })()}
                </div>
                {(() => {
                  const { score } = getStageInfo("Assessments");
                  if (score !== null) {
                    return (
                      <div className="type-btn-score">
                        <p>{score ? `${score.toFixed(2)}%` : "--"}</p>
                      </div>
                    );
                  }
                  return null;
                })()}
              </div>
            </div>
            <div>
              <div
                className={testType === 3 ? "type-btn active-type" : "type-btn"}
                onClick={() => changeType(3)}
              >
                <div className="type-btn-status">
                  <h4>Video Interview</h4>
                  {(() => {
                    const { status } = getStageInfo("Video Interview");
                    return (
                      <h5
                        style={{
                          color: STATUS_COLORS[status],
                        }}
                      >
                        {status}
                      </h5>
                    );
                  })()}
                </div>
                {(() => {
                  const { score } = getStageInfo("Video Interview");
                  if (score !== null) {
                    return (
                      <div className="type-btn-score">
                        <p>{score ? `${score.toFixed(2)}%` : "--"}</p>
                      </div>
                    );
                  }
                  return null;
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E4E9F0",
          borderRadius: "4px",
          borderTopLeftRadius: "0",
          borderTopRightRadius: "0",
        }}
      >
        {testType === 1 && (
          <div
            className="candidate-assessment-details"
            style={{ flexDirection: "column" }}
          >
            {tabLoading ? (
              <div
                className="loading-overlay"
                style={{
                  position: "relative",
                  marginTop: 16,
                  alignItems: "start",
                }}
              >
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {(voiceSession?.status === "Ended" && voiceSession?.result) ||
                (voiceSession?.status === "Completed" &&
                  voiceSession?.result) ? (
                  <>
                    <div
                      className="candidate-score d-flex flex-row"
                      style={{
                        gap: "46px",
                        padding: "0 32px",
                        overflowX: "auto",
                        scrollbarWidth: "thin",
                      }}
                    >
                      <div
                        className="candidate-score-container"
                        style={{ width: "180px", height: "180px" }}
                      >
                        <CircularProgressRing
                          percentage={voiceSession?.result?.overall_score || 0}
                          label="Voice interview"
                        />
                      </div>
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ gap: "24px" }}
                      >
                        {voiceSession?.result?.analysis
                          ?.structured_analysis && (
                          <div className="d-flex" style={{ gap: "24px" }}>
                            <div className="voice-score">
                              <h6>
                                {
                                  voiceSession?.result?.analysis
                                    ?.structured_analysis
                                    ?.communication_weighted_score
                                }
                                /
                                {voiceSession?.result?.analysis
                                  ?.structured_analysis?.weights_used
                                  ?.communication || "25"}
                              </h6>
                              <p>Communication Weighted Score</p>
                            </div>
                            <div className="voice-score">
                              <h6>
                                {
                                  voiceSession?.result?.analysis
                                    ?.structured_analysis
                                    ?.technical_weighted_score
                                }
                                /
                                {voiceSession?.result?.analysis
                                  ?.structured_analysis?.weights_used
                                  ?.technical || "60"}
                              </h6>
                              <p>Technical Weighted Score</p>
                              <button onClick={() => handleScoreClick("technical")}>View</button>
                            </div>
                            <div className="voice-score">
                              <h6>
                                {
                                  voiceSession?.result?.analysis
                                    ?.structured_analysis
                                    ?.cultural_fit_weighted_score
                                }
                                /
                                {voiceSession?.result?.analysis
                                  ?.structured_analysis?.weights_used
                                  ?.cultural_fit || "15"}
                              </h6>
                              <p>Cultural Fit Weighted Score</p>
                              <button onClick={() => handleScoreClick("cultural")}>View</button>
                            </div>
                            <div className="voice-score">
                              <h6>
                                {
                                  voiceSession?.result?.analysis
                                    ?.structured_analysis?.final_weighted_score
                                }
                                /100
                              </h6>
                              <p>Final Weighted Score</p>
                              <button onClick={() => handleScoreClick("final")}>View</button>
                            </div>
                          </div>
                        )}
                        <div className="voice-score">
                          {voiceSession?.completed_at ? (
                            <div>
                              <h6 style={{ height: "unset", fontSize: "20px" }}>
                                {new Date(voiceSession.completed_at)
                                  .toLocaleString(undefined, {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                  })
                                  .replace(",", "")}
                              </h6>
                              <p style={{ height: "unset" }}>Completed</p>
                            </div>
                          ) : (
                            <div>
                              <h6 style={{ height: "unset", fontSize: "20px" }}>
                                {new Date(voiceSession.updated_at)
                                  .toLocaleString(undefined, {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                  })
                                  .replace(",", "")}
                              </h6>
                              <p style={{ height: "unset" }}>Completed</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className="candidate-assessment-items"
                      style={{ width: "100%", borderRadius: "none" }}
                    >
                      <div className="assessment-score">
                        <div className="assessment-score-sections">
                          <div
                            className="assessment-score-summary"
                            style={{
                              width: voiceSession?.result?.recommendation
                                ? "50%"
                                : "100%",
                            }}
                          >
                            <div
                              style={{
                                borderRight: "1px solid #e5e7eb",
                                paddingRight: "20px",
                              }}
                            >
                              <h5>Summary</h5>
                              <div className="text-summary-container">
                                <p
                                  className={`summary-text ${
                                    expandSummary ? "expanded" : "clamped"
                                  }`}
                                >
                                  {voiceSession?.result?.summary}
                                </p>
                                {!expandSummary && (
                                  <span
                                    className="read-more"
                                    onClick={() => setExpandSummary(true)}
                                  >
                                    View more
                                  </span>
                                )}
                                {expandSummary && (
                                  <span
                                    className="read-more"
                                    onClick={() => setExpandSummary(false)}
                                  >
                                    View less
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          {voiceSession?.result?.recommendation && (
                            <div
                              className="assessment-score-summary"
                              style={{ width: "50%" }}
                            >
                              <h5>Recommendation</h5>
                              <div className="text-summary-container">
                                <p
                                  className={`summary-text ${
                                    expandRecommendation
                                      ? "expanded"
                                      : "clamped"
                                  }`}
                                >
                                  {voiceSession.result.recommendation}
                                </p>
                                {!expandRecommendation && (
                                  <span
                                    className="read-more"
                                    onClick={() =>
                                      setExpandRecommendation(true)
                                    }
                                  >
                                    View more
                                  </span>
                                )}
                                {expandRecommendation && (
                                  <span
                                    className="read-more"
                                    onClick={() =>
                                      setExpandRecommendation(false)
                                    }
                                  >
                                    View less
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {!currentStage ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        {!isSharedReport && (
                        <button
                          className="candidate-assessment-calling"
                          onClick={() => {
                            const hasCountryCode = /^\+\d{1,3}/.test(
                              candidate?.phone_number || ""
                            );
                            if (hasCountryCode) {
                              handleVoiceCall();
                            } else {
                              setShowPhoneCheckModal(true);
                            }
                          }}
                          disabled={loadingCall}
                        >
                          {loadingCall
                            ? "Initiating call..."
                            : "Make a voice call"}
                        </button>
                        )}
                        {!isSharedReport && (
                        <button
                          className="candidate-assessment-calling"
                          onClick={() => {
                            const hasCountryCode = /^\+\d{1,3}/.test(
                              candidate?.phone_number || ""
                            );
                            if (hasCountryCode) {
                              setShowVideoModal(true);
                              setModalType("voice");
                              const formattedDate =
                                moment(scheduleDate).format("YYYY-MM-DD");
                              dispatch(
                                fetchAvailableSlots(jobId, formattedDate)
                              );
                            } else {
                              setShowPhoneCheckModal(true);
                            }
                          }}
                          disabled={initiatingVideoCall}
                        >
                          Schedule a voice interview
                        </button>
                        )}
                      </div>
                    ) : currentStatus === "ASSIGNED" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <p className="d-flex align-items-center">
                          Voice Call assigned, yet to be scheduled
                        </p>
                      </div>
                    ) : currentStatus === "NOT SCHEDULED" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <p className="d-flex align-items-center">
                          Voice Call assigned, yet to be scheduled
                        </p>
                      </div>
                    ) : currentStatus === "SCHEDULED" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <p>
                          Voice Call scheduled at{" "}
                          {formatDateTime(currentStage.scheduled_at)}
                        </p>
                      </div>
                    ) : currentStatus === "ONGOING" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{
                          border: "none",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <p>Voice Call is in progress</p>
                        <button
                          className="refresh-btn"
                          onClick={handleVoiceRefresh}
                          disabled={refreshing}
                        >
                          <img
                            src="/images/reset.svg"
                            alt=""
                            width={16}
                            height={16}
                          />
                        </button>
                      </div>
                    ) : currentStatus === "EXPIRED" ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <div>
                          <div className="d-flex">
                            {!isSharedReport && (
                            <button
                              className="candidate-assessment-calling"
                              onClick={() => {
                                const hasCountryCode = /^\+\d{1,3}/.test(
                                  candidate?.phone_number || ""
                                );
                                if (hasCountryCode) {
                                  handleVoiceCall();
                                } else {
                                  setShowPhoneCheckModal(true);
                                }
                              }}
                              disabled={loadingCall}
                            >
                              {loadingCall
                                ? "Initiating call..."
                                : "Make a voice call again"}
                            </button>
                            )}
                            &nbsp;&nbsp;
                            {!isSharedReport && (
                            <button
                              className="candidate-assessment-calling"
                              onClick={() => {
                                const hasCountryCode = /^\+\d{1,3}/.test(
                                  candidate?.phone_number || ""
                                );
                                if (hasCountryCode) {
                                  setShowVideoModal(true);
                                  setModalType("voice");
                                  const formattedDate =
                                    moment(scheduleDate).format("YYYY-MM-DD");
                                  dispatch(
                                    fetchAvailableSlots(jobId, formattedDate)
                                  );
                                } else {
                                  setShowPhoneCheckModal(true);
                                }
                              }}
                              disabled={initiatingVideoCall}
                            >
                              Schedule a voice interview
                            </button>
                            )}
                          </div>
                          <p
                            className="d-flex align-items-center"
                            style={{ color: "#FF5733" }}
                          >
                            Voice call stage has been expired
                          </p>
                        </div>
                      </div>
                    ) : ["FAILED", "NOT COMPLETED", "REVOKED"].includes(
                        currentStatus
                      ) ? (
                      <div
                        className="candidate-assessment-items"
                        style={{ border: "none", width: "100%" }}
                      >
                        <div>
                          <div className="d-flex">
                            {!isSharedReport && (
                            <button
                              className="candidate-assessment-calling"
                              onClick={() => {
                                const hasCountryCode = /^\+\d{1,3}/.test(
                                  candidate?.phone_number || ""
                                );
                                if (hasCountryCode) {
                                  handleVoiceCall();
                                } else {
                                  setShowPhoneCheckModal(true);
                                }
                              }}
                              disabled={loadingCall}
                            >
                              {loadingCall
                                ? "Initiating call..."
                                : "Make a voice call again"}
                            </button>
                            )}
                            &nbsp;&nbsp;
                            {!isSharedReport && (
                            <button
                              className="candidate-assessment-calling"
                              onClick={() => {
                                const hasCountryCode = /^\+\d{1,3}/.test(
                                  candidate?.phone_number || ""
                                );
                                if (hasCountryCode) {
                                  setShowVideoModal(true);
                                  setModalType("voice");
                                  const formattedDate =
                                    moment(scheduleDate).format("YYYY-MM-DD");
                                  dispatch(
                                    fetchAvailableSlots(jobId, formattedDate)
                                  );
                                } else {
                                  setShowPhoneCheckModal(true);
                                }
                              }}
                              disabled={initiatingVideoCall}
                            >
                              Schedule a voice interview
                            </button>
                            )}
                          </div>
                          <p
                            className="d-flex align-items-center"
                            style={{ color: "#FF5733", marginTop: "10px" }}
                          >
                            Voice call failed{" "}
                            {voiceSession?.meta_data?.failure_reason && (
                              <>
                                Reason: {voiceSession.meta_data.failure_reason}
                              </>
                            )}
                          </p>
                        </div>
                      </div>
                    ) : (currentStatus === "COMPLETED" &&
                        voiceSession?.result === "null") ||
                      (currentStatus === "COMPLETED" &&
                        voiceSession?.result === null) ? (
                      <div
                        className="candidate-assessment-items"
                        style={{
                          border: "none",
                          width: "100%",
                          borderRadius: "none",
                        }}
                      >
                        <p>
                          Voice Call is Completed waiting for result to get
                          updated
                        </p>
                      </div>
                    ) : (currentStatus === "COMPLETED" ||
                        voiceSession?.status === "Ended") &&
                      voiceSession?.result ? (
                      <>
                        <div
                          className="candidate-assessment-items"
                          style={{ width: "100%", borderRadius: "none" }}
                        >
                          <div className="candidate-score">
                            <div className="candidate-score-container">
                              <CircularProgressRing
                                percentage={
                                  voiceSession?.result?.overall_score || 0
                                }
                                label="Voice interview"
                              />
                            </div>
                          </div>
                          <div className="assessment-score">
                            <h5>Overall score</h5>
                            <p
                              style={{
                                height: "135px",
                                width: "70%",
                                overflow: "auto",
                                scrollbarWidth: "none",
                              }}
                            >
                              {
                                voiceSession?.result?.analysis
                                  ?.structured_analysis?.summary
                              }
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <p>Unknown or pending state</p>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        )}
        <>
          {testType === 1 && (
            <div className="candidate-assessment-details">
              {tabLoading ? (
                <div
                  className="loading-overlay"
                  style={{
                    position: "relative",
                    marginTop: 16,
                    alignItems: "start",
                  }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
                  {(currentStatus === "COMPLETED" && voiceSession?.result) ||
                  (voiceSession?.status === "Ended" && voiceSession?.result) ||
                  (voiceSession?.status === "Completed" &&
                    voiceSession?.result) ? (
                    <>
                      <div
                        className="candidate-assessment-items"
                        style={{ width: "100%" }}
                      >
                        <div className="candidate-assessment-audio">
                          <h5>Interview audio</h5>
                          {audioLoading && (
                            <div
                              className="loading-overlay"
                              style={{ height: 60, width: "380px" }}
                            >
                              <div className="spinner-border" role="status">
                                <span className="visually-hidden">
                                  Loading audio...
                                </span>
                              </div>
                            </div>
                          )}
                          <div
                            style={{ display: audioLoading ? "none" : "block" }}
                          >
                            <WaveformPlayer
                              audioUrl={voiceSession?.result?.stereo_audio_url}
                              onLoadingChange={setAudioLoading}
                              hideDownload={isSharedReport}
                            />
                          </div>
                        </div>
                        <div
                          className="candidate-assessment-transcript"
                          style={{
                            height: "230px",
                            overflow: "auto",
                            scrollbarWidth: "thin",
                          }}
                        >
                          <h4>Transcript</h4>
                          {voiceSession?.result?.messages?.map((msg, idx) => {
                            if (msg.role === "system" || !msg.message?.trim())
                              return null;
                            const isAgent =
                              msg.role === "bot" ||
                              msg.role === "tool_calls" ||
                              msg.role === "tool_call_result";
                            const speaker = isAgent
                              ? "Agent voice"
                              : candidate?.name;
                            return (
                              <div
                                className="transcript"
                                key={idx}
                                style={{ marginBottom: "10px" }}
                              >
                                <div className="transcript-text">
                                  {isAgent ? (
                                    <img
                                      src="/images/candidate-example.jpeg"
                                      alt="avatar"
                                    />
                                  ) : (
                                    <div className="user-avatar">
                                      {candidate.name
                                        ?.charAt(0)
                                        .toUpperCase() || "U"}
                                    </div>
                                  )}
                                  &nbsp;<h5>{speaker}</h5>
                                </div>
                                <p>{msg.message}</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </>
                  ) : null}
                </>
              )}
            </div>
          )}
        </>
        <>
          {testType === 2 && (
            <>
              <div style={{ padding: "22px 32px" }}>
                {tabLoading ? (
                  <div
                    className="loading-overlay"
                    style={{
                      position: "relative",
                      marginTop: 16,
                      alignItems: "start",
                    }}
                  >
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <>
                    {!currentStage ? (
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "10px" }}
                      >
                        {!latestJob?.assessment_id ||
                        latestJob?.assessment_id === null ? (
                          <>
                            <p
                              style={{
                                color: "#6b7280",
                                fontSize: "14px",
                                fontWeight: 500,
                              }}
                            >
                              Assessment was not added. Add it by navigating to
                              My Assessments.
                            </p>
                            {!isSharedReport && (
                            <button
                              className="candidate-assessment-calling"
                              onClick={() => navigate("/assessments")}
                            >
                              My Assessments
                            </button>
                            )}
                          </>
                        ) : (
                          !isSharedReport && (
                            <button
                              className="candidate-assessment-calling"
                              onClick={() => {
                                setShowVideoModal(true);
                                setModalType("assessment");
                              }}
                              disabled={initiatingVideoCall}
                            >
                              {assessmentStatus === "sending"
                                ? "Assessment sending to candidate..."
                                : assessmentStatus === "sent"
                                ? "Assessment sent to candidate"
                                : "Send an assessment invite"}
                            </button>
                            )
                        )}
                      </div>
                    ) : currentStatus === "ASSIGNED" ? (
                      <p>Assessment assigned, yet to be completed</p>
                    ) : currentStatus === "NOT SCHEDULED" ? (
                      <p>Assessment assigned, yet to be scheduled</p>
                    ) : currentStatus === "SCHEDULED" ? (
                      <p>
                        Assessment Invite sent. Due date -{" "}
                        {formatDateOnly(currentStage.expire_at)}
                      </p>
                    ) : currentStatus === "ONGOING" ? (
                      <p>Assessment in progress</p>
                    ) : currentStatus === "EXPIRED" ? (
                      <div>
                        {!isSharedReport && (
                        <button
                          className="candidate-assessment-calling"
                          onClick={() => {
                            setShowVideoModal(true);
                            setModalType("assessment");
                          }}
                          disabled={initiatingVideoCall}
                        >
                          {assessmentStatus === "sending"
                            ? "Assessment sending to candidate..."
                            : assessmentStatus === "sent"
                            ? "Assessment sent to candidate"
                            : "Send an assessment invite"}
                        </button>
                        )}
                        <p>Assessment stage expired</p>
                      </div>
                    ) : ["FAILED", "NOT COMPLETED", "REVOKED"].includes(
                        currentStatus
                      ) ? (
                      <div>
                        {!isSharedReport && (
                        <button
                          className="candidate-assessment-calling"
                          onClick={() => {
                            setShowVideoModal(true);
                            setModalType("assessment");
                          }}
                          disabled={initiatingVideoCall}
                        >
                          {assessmentStatus === "sending"
                            ? "Assessment sending to candidate..."
                            : assessmentStatus === "sent"
                            ? "Assessment sent to candidate"
                            : "Send an assessment invite"}
                        </button>
                        )}
                        <p>Assessment failed or not completed</p>
                      </div>
                    ) : currentStatus === "COMPLETED" &&
                      assessmentInviteDetails ? (
                      assessmentInviteDetails.status === 3 ? (
                        <TestReport
                          overrideState={{
                            id: assessmentInviteDetails.inviteId,
                            type: "new",
                          }}
                          isSharedReport={isSharedReport}
                          useSharedToken={props.useSharedToken}
                        />
                      ) : (
                        <div
                          style={{
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                          }}
                        >
                          <Table
                            responsive
                            className="job-table"
                            style={{ margin: "0" }}
                          >
                            <thead>
                              <tr
                                style={{
                                  borderTopLeftRadius: "8px",
                                  borderTopRightRadius: "8px",
                                }}
                              >
                                <th>Test</th>
                                <th>Test Attempt Date</th>
                                <th>Score</th>
                                <th>Status</th>
                                <th>View</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr style={{ borderBottom: "0px" }}>
                                <td>{assessmentInviteDetails.testName}</td>
                                <td>
                                  {assessmentInviteDetails.testAttemptDate
                                    ? formatDateTime(
                                        assessmentInviteDetails.testAttemptDate
                                      )
                                    : "--"}
                                </td>
                                <td>
                                  {assessmentInviteDetails.status === 3
                                    ? `${
                                        assessmentInviteDetails.score ?? "N/A"
                                      }%`
                                    : "--"}
                                </td>
                                <td>
                                  {{
                                    1: "Invited",
                                    2: "Pending",
                                    3: "Completed",
                                  }[assessmentInviteDetails.status] ||
                                    "Unknown"}
                                </td>
                                <td>
                                  {assessmentInviteDetails?.status === 3 &&
                                    assessmentInviteDetails?.inviteId && (
                                      <img
                                        className="cursor-pointer"
                                        src="/images/view-icon.svg"
                                        alt="View"
                                        onClick={() => {
                                          setInlineReportId(
                                            assessmentInviteDetails.inviteId
                                          );
                                          setShowInlineReport(
                                            !showInlineReport
                                          );
                                        }}
                                      />
                                    )}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      )
                    ) : (
                      <p>Status pending or unknown</p>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </>
        {testType === 3 && (
          <div className="candidate-assessment-details">
            {console.log("videoSession", videoSession)}
            {tabLoading ? (
              <div
                className="loading-overlay"
                style={{
                  position: "relative",
                  marginTop: 16,
                  alignItems: "start",
                }}
              >
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {(() => {
                  const normalize = (v) => (v || "").trim().toLowerCase();
                  const videoStatus = normalize(videoSession?.status);
                  const safeCurrentStatus = normalize(currentStatus);

                  return (
                    <>
                      {videoStatus === "completed" && videoSession?.result ? (
                        <>
                          <div
                            className="candidate-assessment-items"
                            style={{ width: "100%" }}
                          >
                            <div className="candidate-score">
                              <div className="candidate-score-container">
                                <CircularProgressRing
                                  percentage={
                                    videoSession?.result?.overall_rating ||
                                    videoSession?.score?.toFixed?.(2) ||
                                    0
                                  }
                                  label="Video score"
                                />
                              </div>
                            </div>

                            <div
                              className="assessment-score d-flex"
                              style={{ gap: "20px", width: "100%" }}
                            >
                              {/* LEFT SECTION */}
                              <div
                                style={{
                                  width: "50%",
                                  paddingRight: "20px",
                                  borderRight: "1px solid #ccc",
                                }}
                              >
                                <h5>Overall score</h5>
                                <p
                                  style={{
                                    height: "135px",
                                    overflow: "auto",
                                    scrollbarWidth: "none",
                                  }}
                                >
                                  {videoSession?.result?.technical_skills
                                    ?.description ||
                                    videoSession?.result?.overall_impression}
                                </p>
                              </div>

                              {/* RIGHT SECTION */}
                              <div
                                style={{
                                  width: "50%",
                                  height: "150px",
                                  overflowX: "auto",
                                  scrollbarWidth: "thin",
                                }}
                              >
                                {videoSession?.result?.technical_score && (
                                  <p>
                                    Technical score:{" "}
                                    {videoSession?.result?.technical_score.toFixed(
                                      2
                                    )}
                                    /80
                                  </p>
                                )}

                                {videoSession?.result?.behavioral_score && (
                                  <p>
                                    Behavioural score:{" "}
                                    {videoSession?.result?.behavioral_score.toFixed(
                                      2
                                    )}
                                    /20
                                  </p>
                                )}

                                {videoSession?.result?.total_score && (
                                  <p>
                                    Total score:{" "}
                                    {videoSession?.result?.total_score.toFixed(
                                      2
                                    )}
                                    /100
                                  </p>
                                )}

                                <br />

                                {videoSession?.result?.skill_coverage && (
                                  <>
                                    <p>
                                      Skill coverage:{" "}
                                      {Object.entries(
                                        videoSession.result.skill_coverage
                                      ).map(([skill, score], index) => (
                                        <span
                                          className="candidate-skills"
                                          key={index}
                                        >
                                          {skill} : {score}/10,
                                        </span>
                                      ))}
                                    </p>
                                    <br />
                                  </>
                                )}

                                {videoSession?.result?.strengths?.length >
                                  0 && (
                                  <>
                                    <div>
                                      <p>Strengths: </p>
                                      <ul>
                                        {videoSession.result.strengths.map(
                                          (point, idx) => (
                                            <li key={idx}>{point}</li>
                                          )
                                        )}
                                      </ul>
                                    </div>
                                    <br />
                                  </>
                                )}

                                {videoSession?.result?.areas_for_improvement
                                  ?.length > 0 && (
                                  <div>
                                    <p>Areas of improvement: </p>
                                    <ul>
                                      {videoSession.result.areas_for_improvement.map(
                                        (point, idx) => (
                                          <li key={idx}>{point}</li>
                                        )
                                      )}
                                    </ul>
                                  </div>
                                )}

                                {videoSession?.ended_at && (
                                  <p>
                                    Completed On:{" "}
                                    {new Date(videoSession.ended_at)
                                      .toLocaleString(undefined, {
                                        day: "numeric",
                                        month: "long",
                                        year: "numeric",
                                      })
                                      .replace(",", "")}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          {!currentStage ? (
                            <div
                              className="candidate-assessment-items"
                              style={{ border: "none", width: "100%" }}
                            >
                              {!isSharedReport && (
                              <button
                                className="candidate-assessment-calling"
                                onClick={() => {
                                  setShowVideoModal(true);
                                  setModalType("video");
                                }}
                                disabled={initiatingVideoCall}
                              >
                                {initiatingVideoCall
                                  ? "Initiating call..."
                                  : "Schedule a video interview"}
                              </button>
                              )}
                            </div>
                          ) : safeCurrentStatus === "assigned" ? (
                            <div
                              className="candidate-assessment-items"
                              style={{ border: "none", width: "100%" }}
                            >
                              <p>
                                Video Interview assigned, yet to be completed
                              </p>
                            </div>
                          ) : safeCurrentStatus === "not scheduled" ? (
                            <div
                              className="candidate-assessment-items"
                              style={{ border: "none", width: "100%" }}
                            >
                              <p>
                                Video Interview assigned, yet to be scheduled
                              </p>
                            </div>
                          ) : safeCurrentStatus === "scheduled" ? (
                            <div
                              className="candidate-assessment-items"
                              style={{ border: "none", width: "100%" }}
                            >
                              <p>
                                Video Interview sent. Due at{" "}
                                {formatDateOnly(currentStage.expire_at)}
                              </p>
                            </div>
                          ) : safeCurrentStatus === "ongoing" ? (
                            <div
                              className="candidate-assessment-items"
                              style={{ border: "none", width: "100%" }}
                            >
                              <p>Video Interview is in progress</p>
                            </div>
                          ) : safeCurrentStatus === "expired" ? (
                            <div
                              className="candidate-assessment-items"
                              style={{
                                border: "none",
                                width: "100%",
                                display: "block",
                              }}
                            >
                              {!isSharedReport && (
                              <button
                                className="candidate-assessment-calling"
                                onClick={() => {
                                  setShowVideoModal(true);
                                  setModalType("video");
                                }}
                                disabled={initiatingVideoCall}
                                style={{ width: "unset" }}
                              >
                                {initiatingVideoCall
                                  ? "Initiating call..."
                                  : "Schedule a video interview again"}
                              </button>
                              )}
                              <p
                                className="d-flex align-items-center"
                                style={{ color: "#FF5733" }}
                              >
                                video call stage expired
                              </p>
                            </div>
                          ) : ["failed", "not completed", "revoked"].includes(
                              safeCurrentStatus
                            ) ? (
                            <div
                              className="candidate-assessment-items"
                              style={{
                                border: "none",
                                width: "100%",
                                display: "block",
                              }}
                            >
                              {!isSharedReport && (
                              <button
                                className="candidate-assessment-calling"
                                onClick={() => {
                                  setShowVideoModal(true);
                                  setModalType("video");
                                }}
                                disabled={initiatingVideoCall}
                                style={{ width: "unset" }}
                              >
                                {initiatingVideoCall
                                  ? "Initiating call..."
                                  : "Schedule a video interview again"}
                              </button>
                              )}
                              <p
                                className="d-flex align-items-center"
                                style={{ color: "#FF5733" }}
                              >
                                video call was attempted but not responded by
                                the candidate.
                              </p>
                            </div>
                          ) : safeCurrentStatus === "completed" &&
                            videoSession?.result ? (
                            <>
                              <div
                                className="candidate-assessment-items"
                                style={{ width: "100%" }}
                              >
                                <div className="candidate-score">
                                  <div className="candidate-score-container">
                                    <CircularProgressRing
                                      percentage={
                                        videoSession?.result?.overall_rating ||
                                        0
                                      }
                                      label="Video score"
                                    />
                                  </div>
                                </div>
                                <div className="assessment-score">
                                  <h5>Overall score</h5>
                                  <p
                                    style={{
                                      height: "135px",
                                      width: "70%",
                                      overflow: "auto",
                                      scrollbarWidth: "none",
                                    }}
                                  >
                                    {
                                      videoSession?.result?.technical_skills
                                        ?.description
                                    }
                                  </p>
                                </div>
                              </div>
                            </>
                          ) : safeCurrentStatus === "completed" &&
                            !videoSession?.result ? (
                            <div
                              className="candidate-assessment-items"
                              style={{ border: "none", width: "100%" }}
                            >
                              <p>
                                Video interview completed, waiting for result
                              </p>
                            </div>
                          ) : (
                            <div
                              className="candidate-assessment-items"
                              style={{ border: "none", width: "100%" }}
                            >
                              <p>Status pending or unknown</p>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  );
                })()}
              </>
            )}
          </div>
        )}
        <>
          {testType === 3 && (
            <div className="candidate-assessment-details">
              {tabLoading ? (
                <div
                  className="loading-overlay"
                  style={{
                    position: "relative",
                    marginTop: 16,
                    alignItems: "start",
                  }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
                  {(currentStatus === "COMPLETED" && videoSession?.result) ||
                  (videoSession?.status === "Completed" &&
                    videoSession?.result) ? (
                    <>
                      <div
                        className="candidate-assessment-items"
                        style={{ width: "100%" }}
                      >
                        <div className="candidate-assessment-video">
                          <h5>Video interview</h5>
                          <ReactPlayer
                            className="assessment-video"
                            url={videoSession?.recording_link}
                            controls={true}
                            playing={isPlaying}
                            width="100%"
                            height="100%"
                            onPlay={() => setIsPlaying(true)}
                            onPause={() => setIsPlaying(false)}
                            config={{
                              file: {
                                attributes: {
                                  controlsList: "nodownload",
                                  preload: "metadata",
                                },
                              },
                            }}
                          />
                          {!isPlaying &&
                          videoSession?.recording_link_status ===
                            "Completed" ? (
                            <div
                              onClick={() => setIsPlaying(true)}
                              className="player-svg"
                            >
                              <FaPlay size={30} color="#FFFFFF" />
                            </div>
                          ) : null}
                        </div>
                        <div
                          className="candidate-assessment-transcript"
                          style={{
                            height: "385px",
                            overflow: "auto",
                            scrollbarWidth: "thin",
                          }}
                        >
                          <h4>Transcript</h4>
                          {videoSession?.transcripts?.map((msg, idx) => {
                            if (!msg.content?.trim()) return null;
                            const isAgent = msg.content_by === "AI";
                            const speaker = isAgent
                              ? "Agent voice"
                              : msg.content_by;
                            return (
                              <div
                                className="transcript"
                                key={idx}
                                style={{ marginBottom: "10px" }}
                              >
                                <div className="transcript-text">
                                  {isAgent ? (
                                    <img
                                      src="/images/candidate-example.jpeg"
                                      alt="avatar"
                                    />
                                  ) : (
                                    <div className="user-avatar">
                                      {msg.content_by
                                        ?.charAt(0)
                                        .toUpperCase() || "U"}
                                    </div>
                                  )}
                                  &nbsp;<h5>{speaker}</h5>
                                </div>
                                <p>{msg.content}</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </>
                  ) : null}
                </>
              )}
            </div>
          )}
        </>
        <>
          {testType === 3 && proctoring && cheatingFrames.length > 0 && (
            <div className="candidate-assessment-details mt-4">
              <div className="image-lists">
                <h4>Proctoring Analysis</h4>
                <div className="proctoring-report">
                  <div className="proctoring-report-item">
                    <div className="proctoring-report-count">
                      <h6>{cheatingFrames.length}</h6>
                    </div>
                    <p>Cheating detected in frames</p>
                  </div>
                </div>
                <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
                  {(showAllCheatingImages
                    ? cheatingFrames
                    : cheatingFrames.slice(0, 8)
                  ).map((frame, index) => (
                    <div
                      key={index}
                      className="image-list"
                      style={{
                        width: "160px",
                        height: "90px",
                        overflow: "hidden",
                        borderRadius: "8px",
                        cursor: "pointer",
                        position: "relative",
                        border: "3px solid red",
                      }}
                    >
                      <img
                        src={frame.image_url}
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                        alt=""
                        data-bs-toggle="tooltip"
                        title={frame?.llm_eval?.summary || ""}
                        onClick={() => {
                          setSelectedProctorIndex(index);
                          setSelectedProctorImage(frame.image_url);
                          setOpenProctorLightbox(true);
                        }}
                      />
                    </div>
                  ))}
                </div>
                {cheatingFrames.length > 8 && (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      marginTop: "15px",
                      cursor: "pointer",
                      fontWeight: 600,
                      color: "#0048b7",
                    }}
                    onClick={() =>
                      setShowAllCheatingImages(!showAllCheatingImages)
                    }
                  >
                    {showAllCheatingImages ? "View Less" : "View All"}
                  </div>
                )}
              </div>
            </div>
          )}
        </>
        {testType === 0 && (
          <div className="pre-screening-section">
            {tabLoading ? (
              <div className="loading-overlay" style={{ alignItems: "unset" }}>
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {(() => {
                  const PRE_SCREENING_STAGE_ID =
                    "3dab71cf-c680-4983-a109-1cff0953999b";
                  const preScreeningStages =
                    candidate?.hiring_stages?.filter(
                      (stage) =>
                        stage.hiring_stage_id === PRE_SCREENING_STAGE_ID
                    ) || [];
                  let preScreeningStage = null;
                  if (preScreeningStages.length > 0) {
                    preScreeningStage = preScreeningStages.reduce(
                      (latest, curr) =>
                        new Date(curr.created_at) > new Date(latest.created_at)
                          ? curr
                          : latest
                    );
                  }
                  const status = (preScreeningStage?.status?.name || "")
                    .trim()
                    .toLowerCase();
                  if (status === "completed") {
                    return (
                      <>
                        <div className="pre-screening-items">
                          {preQualifyingReport?.length > 0 &&
                          preQualifyingReport[0]?.evaluations?.length > 0 ? (
                            <div className="pre-screening-item">
                              <div>
                                <h4>
                                  Prescreening score:{" "}
                                  {preQualifyingReport?.[0]?.total_score.toFixed(
                                    2
                                  )}
                                  %
                                </h4>
                              </div>

                              <div className="question-block-heading">
                                <h5 className="question-block-heading-question">
                                  Question
                                </h5>
                                <h5 className="question-block-heading-options">
                                  Suggested answer/options
                                </h5>
                                <h5 className="question-block-heading-answer">
                                  Candidate Answer
                                </h5>
                                <h5 className="question-block-heading-score">
                                  Score
                                </h5>
                              </div>
                              {preQualifyingReport[0].evaluations.map(
                                (evalItem, idx) => {
                                  const typeLabel =
                                    QUESTION_TYPE_ID_TO_LABEL[
                                      evalItem.question?.question_type_id
                                    ] || "Unknown";

                                  const isMCQ =
                                    evalItem.question?.question_type_id ===
                                    "4c524f2f-48de-493e-894f-4f0bd931b4c9";

                                  // correct answer text
                                  const correctAnswer =
                                    evalItem.question?.meta_data
                                      ?.required_answer_text ||
                                    evalItem.question?.meta_data
                                      ?.required_option_text ||
                                    null;

                                  // candidate answer text
                                  const candidateAnswer =
                                    evalItem.answer_text ||
                                    evalItem.selected_option?.option_text ||
                                    null;

                                  // check correctness
                                  const isCorrect =
                                    candidateAnswer &&
                                    correctAnswer &&
                                    candidateAnswer.trim().toLowerCase() ===
                                      correctAnswer.trim().toLowerCase();

                                  return (
                                    <>
                                      {evalItem.question && (
                                        <div
                                          key={evalItem.id}
                                          className="question-block"
                                        >
                                          <div className="question-block-details">
                                            <div className="question-block-question">
                                              <h5>{typeLabel}</h5>
                                              <p>
                                                {
                                                  evalItem.question
                                                    ?.question_text
                                                }
                                              </p>
                                            </div>
                                          </div>
                                          <div className="d-flex flex-wrap">
                                            {isMCQ ? (
                                              <div className="d-flex flex-wrap">
                                                {evalItem.question?.options?.map(
                                                  (opt) => {
                                                    const isCorrect =
                                                      opt.option_text
                                                        .trim()
                                                        .toLowerCase() ===
                                                      (
                                                        evalItem.question
                                                          ?.meta_data
                                                          ?.required_option_text ||
                                                        ""
                                                      )
                                                        .trim()
                                                        .toLowerCase();

                                                    return (
                                                      <p
                                                        key={opt.id}
                                                        style={{
                                                          fontWeight: isCorrect
                                                            ? "700"
                                                            : "400",
                                                          color: isCorrect
                                                            ? "green"
                                                            : "",
                                                          marginRight: "8px",
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        {opt.option_text}
                                                      </p>
                                                    );
                                                  }
                                                )}
                                              </div>
                                            ) : (
                                              <div>
                                                <p style={{ fontSize: "12px" }}>
                                                  {evalItem.question?.meta_data
                                                    ?.required_answer_text ||
                                                    evalItem.question?.meta_data
                                                      ?.required_option_text ||
                                                    "N/A"}
                                                </p>
                                              </div>
                                            )}
                                          </div>
                                          <div className="question-block-answer">
                                            {isMCQ ? (
                                              <div>
                                                <p>
                                                  {candidateAnswer || "N/A"}
                                                </p>
                                              </div>
                                            ) : (
                                              <div>
                                                <p>
                                                  {candidateAnswer || "N/A"}
                                                </p>
                                              </div>
                                            )}
                                          </div>
                                          <div className="question-block-score">
                                            <p>
                                              {evalItem.score
                                                ? evalItem.score
                                                : 0}
                                              /{evalItem.question?.score || 0}
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  );
                                }
                              )}
                            </div>
                          ) : (
                            <p>
                              Pre-Screening test not assigned or not completed
                              yet
                            </p>
                          )}
                        </div>
                      </>
                    );
                  } else if (status === "assigned" || status === "scheduled") {
                    return (
                      <p>Pre-Screening test assigned but not completed yet Expiry: {formatExpiry(preScreeningStage?.expire_at)}</p>
                    );
                  } else if (status === "ongoing") {
                    return <p>Pre-Screening test Ongoing not completed yet Expiry: {formatExpiry(preScreeningStage?.expire_at)}</p>;
                  } else if (!status || status === "not scheduled") {
                    return (
                      !isSharedReport && (
                      <button
                        className="candidate-assessment-calling"
                        onClick={() => {
                            setPreselectStage("Pre Screening");
                            setIsOpen(true);
                        }}
                      >
                        Assign Pre-Screening Test
                      </button>
                      )
                    );
                  } else if (status === "expired") {
                    return (
                      <>
                        <p style={{ color: "red" }}>Pre-Screening Expired</p>
                        &nbsp;
                        {!isSharedReport && (
                        <button
                          className="candidate-assessment-calling"
                          onClick={() => {
                            setPreselectStage("Pre Screening");
                            setIsOpen(true);
                        }}
                        >
                          Assign Pre-Screening Test
                        </button>
                        )}
                      </>
                    );
                  } else if (status === "failed") {
                    return (
                      <>
                        <p style={{ color: "red" }}>Pre-Screening Failed</p>
                        &nbsp;
                        {!isSharedReport && (
                        <button
                          className="candidate-assessment-calling"
                          onClick={() => {
                            setPreselectStage("Pre Screening");
                            setIsOpen(true);
                          }}
                        >
                          Assign Pre-Screening Test
                        </button>
                        )}
                      </>
                    );
                  } else {
                    return <p>Pre-Screening sent to candidate</p>;
                  }
                })()}
              </>
            )}
          </div>
        )}
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackOpen}
        autoHideDuration={3000}
        onClose={snackClosed}
      >
        <Alert
          onClose={snackClosed}
          severity={snackSeverity}
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
      {showSummaryPopup && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: "600px", height: "auto" }}
          >
            <div className="modal-head">
              <h3>Resume Summary</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setShowSummaryPopup(false)}
              />
            </div>
            <div
              className="modal-input"
              style={{
                height: "220px",
                width: "auto",
                overflow: "auto",
                justifyContent: "unset",
              }}
            >
              <p>{candidate.assessment_summary || "No summary available."}</p>
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={() => setShowSummaryPopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showAssistantModal && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: "600px", height: "auto" }}
          >
            <div className="modal-head">
              <h3>Make a voice call with this assistant</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (currentAudio) currentAudio.pause();
                  setShowAssistantModal(false);
                }}
              />
            </div>
            <div className="modal-body">
              {assistants.map((assistant, idx) => (
                <div
                  key={idx}
                  className={`assistant-option ${
                    selectedAssistant?.vapi_assistant_id ===
                    assistant.vapi_assistant_id
                      ? "selected"
                      : ""
                  }`}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "12px",
                    margin: "8px 0",
                    cursor: "pointer",
                    backgroundColor:
                      selectedAssistant?.vapi_assistant_id ===
                      assistant.vapi_assistant_id
                        ? "#f0f0f0"
                        : "white",
                  }}
                  onClick={() => {
                    setSelectedAssistant(assistant);
                  }}
                >
                  <div>
                    {assistant.voice_clip_url && (
                      <label style={{ width: "100%", cursor: "pointer" }}>
                        <input
                          type="radio"
                          name="assistant"
                          value={assistant.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (currentAudio) currentAudio.pause();
                            const audio = new Audio(assistant.voice_clip_url);
                            setCurrentAudio(audio);
                            // audio.play();
                          }}
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {assistant.voice_name}
                      </label>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-center">
              {!isSharedReport && (
              <button
                className="upload-btn"
                disabled={!selectedAssistant}
                style={{ width: "320px" }}
                onClick={async () => {
                  if (currentAudio) currentAudio.pause();
                  setShowAssistantModal(false);
                  const now = new Date();
                  const detectedTz =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;

                  const payload = [
                    {
                      job_hiring_stage_id: filterStageId,
                      job_candidate_id: candidate?.id,
                      schedule_date: now.toISOString(),
                      expire_at: now.toISOString(),
                      valid_till: now.toISOString(),
                      assistant_id: selectedAssistant.id,
                      trigger_now: true,
                      current_timezone: detectedTz,
                      schedule_timezone: detectedTz,
                    },
                  ];

                  setLoadingCall(true);
                  await dispatch(assignedStage(jobId, payload));
                  await dispatch(fetchCandidateProfile(jobId, candidateId));
                  setLoadingCall(false);
                }}
              >
                Make voice call with this assistant
              </button>
              )}
            </div>
          </div>
        </div>
      )}
      {showPhoneCheckModal && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: "500px", height: "auto" }}
          >
            <div className="modal-head">
              <h3>Phone Number Check</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPhoneCheckModal(false)}
              />
            </div>
            <div className="modal-input" style={{ padding: "20px" }}>
              <p>Country code is missing in the mobile number.</p>
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={() => setShowPhoneCheckModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {showVideoModal && (
        <div className="upload-modal">
          <div className="modal-content">
            <div className="modal-head">
              <div></div>
              <h3>
                {modalType === "voice" && "Schedule a voice interview"}
                {modalType === "assessment" && "Send an assessment invite"}
                {modalType === "video" && "Schedule a video interview"}
              </h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                onClick={() => {
                  setShowVideoModal(false);
                  setModalType("");
                }}
                style={{ cursor: "pointer" }}
              />
            </div>
            <div
              className="modal-input d-flex flex-column align-items-start"
              style={{ gap: "15px", padding: "15px" }}
            >
              {modalType === "voice" && (
                <>
                  <div className="modal-input-label">
                    <label>Time Zone</label>
                    <Select
                      options={TimeZone}
                      value={timezone}
                      onChange={setTimezone}
                      placeholder="Select Timezone"
                    />
                  </div>
                </>
              )}
              <div className="modal-input-label">
                <label>Due Date</label>
                <DatePicker
                  selected={scheduleDate}
                  onChange={(date) => setScheduleDate(date)}
                  minDate={new Date()}
                  maxDate={moment().add(15, "days").toDate()}
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                />
              </div>
              {modalType === "voice" && (
                <>
                  <div className="modal-input-label">
                    <label>Time Slot</label>
                    <Select
                      options={availableSlots?.map((slot) => ({
                        label: slot.display,
                        value: slot.id,
                      }))}
                      value={
                        availableSlots
                          ?.map((slot) => ({
                            label: slot.display,
                            value: slot.id,
                          }))
                          .find((opt) => opt.value === slotId) || null
                      }
                      onChange={(selectedOption) =>
                        setSlotId(selectedOption.value)
                      }
                      placeholder="Select a time slot"
                      menuPlacement="bottom"
                      maxMenuHeight={200}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="d-flex justify-content-center">
              {!isSharedReport && (
              <button
                className="upload-btn"
                disabled={stageLoading}
                onClick={sendVideoInvite}
              >
                Submit
              </button>
              )}
            </div>
          </div>
        </div>
      )}
      {showScorePopup && (
        <div className="upload-modal">
          <div
            className="modal-content"
            style={{ width: "600px", height: "auto" }}
          >
            <div className="modal-head">
              <h3>{popupTitle}</h3>
              <img
                src="/images/close-icon.svg"
                alt="close"
                className="cursor-pointer"
                onClick={() => setShowScorePopup(false)}
              />
            </div>

            <div className="modal-body modal-body-text">
              {popupData.length > 0 ? (
                popupData.map((item, index) => (
                  <div className="modal-body-question" key={index}>
                    <div className="d-flex justify-content-between gap-2">
                      <h5 style={{ width: "65%" }}>
                        {index + 1}. <span>{item.question}</span>
                      </h5>
                      <p>Score: {item.score}/5</p>
                    </div>
                    <p>Answer summary: {item.answer_summary}</p>
                  </div>
                ))
              ) : (
                <p>No data available.</p>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={() => setShowScorePopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showSharePopup && (
        <div className="share-modal-overlay">
          <div className="share-modal">
            {/* Header */}
            <div className="share-modal-header">
              <h4>{candidate?.name || "Candidate"}</h4>
              <span onClick={() => {setShareEmails("");setShowSharePopup(false)}}><img src="/images/close-icon.svg" alt="close" className="cursor-pointer"/></span>
            </div>

            {/* Body */}
          {shareLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{height:'120px'}}>
              <div className="spinner-border" role="status"></div>
            </div>
            ) : shareData ? (
              <>
                <h3>Share report</h3>

                <CreatableSelect
                  className="email-input"
                  isMulti
                  placeholder="Enter email ids"
                  value={shareEmails}
                  onChange={changeEmail}
                  styles={{
                    container: (base) => ({ ...base, width: "100%" })
                  }}
                />

                <button className="send-invite-btn" onClick={handleSendInvite} disabled={shareLoading}>
                  {shareLoading ? "Sending email..." : "Send email"}
                </button>

                <div className="share-footer">
                  <div style={{ width: "200px" }}>
                    <button
                      className="copy-link-btn"
                      onClick={() => {
                        navigator.clipboard.writeText(shareData.share_url);
                        showSnack("Link copied!", "success");
                      }}
                    >
                      <img src="/images/copy-outline-wight-icon.svg" alt="" width={16} height={16} />&nbsp;
                      Copy Link
                    </button>

                    <div className="access-code">
                      Share access code <strong>{shareData.access_code}</strong> to view link
                    </div>
                  </div>

                  <button className="done-btn" onClick={() => {setShareEmails("");setShowSharePopup(false)}}>
                    Close
                  </button>
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
      {showAccessModal && (
        <div className="upload-modal">
          <div className="modal-content" style={{ width: "360px" }}>
            <div className="modal-head">
              <div></div>
              <h3>Access Restricted</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setShowAccessModal(false)}
              />
            </div>

            <div style={{ padding: "20px", textAlign: "center" }}>
              <p>You don't have the required access to download this resume.</p>
            </div>

            <div className="d-flex justify-content-center">
              <button
                className="upload-btn"
                onClick={() => setShowAccessModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      
      <ApplyStageModal
        isOpen={isOpen}
        setIsOpen={() => setIsOpen(false)}
        selectAssignedStage={selectAssignedStage}
        jobId={jobId}
        candidateId={candidateId}
        loading={stageLoading}
        assignProgress={assignProgress}
        preselectStage={preselectStage}
        stagePermissions={stagePermissionMap}
      />
      {/* LIGHTBOX FOR PROCTORING IMAGES */}
      <Lightbox
        openBox={openProctorLightbox}
        image={selectedProctorImage}
        closeBox={() => setOpenProctorLightbox(false)}
        showPrev={selectedProctorIndex > 0}
        showNext={selectedProctorIndex < cheatingFrames.length - 1}
        onPrev={() => {
          if (selectedProctorIndex > 0) {
            const newIndex = selectedProctorIndex - 1;
            setSelectedProctorIndex(newIndex);
            setSelectedProctorImage(cheatingFrames[newIndex].image_url);
          }
        }}
        onNext={() => {
          if (selectedProctorIndex < cheatingFrames.length - 1) {
            const newIndex = selectedProctorIndex + 1;
            setSelectedProctorIndex(newIndex);
            setSelectedProctorImage(cheatingFrames[newIndex].image_url);
          }
        }}
      />
    </div>
  );
};

export default CandidateProfile;